
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.2 7C17.6 7 8 17.8 8 30.1s9.6 23.1 22.2 23.1c12.9 0 21.8-10.8 22.2-23.1C52 17.8 43.1 7 30.2 7zm0 43C19.4 50 9.4 41.2 9.4 30.1c0-10.9 9.6-19.6 20.1-19.9 11.3-.4 21.1 8.5 21.5 19.9C50.7 41.2 41.3 50 30.2 50z"}}),_c('path',{attrs:{"d":"M32.5 21.3c-.2-1.2-.9-2.3-2.3-2.3s-2.3 1.4-2.3 2.7c0 1.3.8 2.6 2.2 2.7 1.4.1 2.2-1.1 2.4-2.3v-.4-.4zM29.5 26.8v13.7c0 1.9 1.4 1.9 1.4 0V26.8c0-1.9-1.4-1.9-1.4 0z"}})])
          )
        }
      }
    